import React, { createContext, useState, useReducer } from "react";
import DATA_PRODS from "../data";
import { ProductReducer } from "./CartReducer";
import { FILTER_PRODUCTS_BY_BRAND } from "./Types";
// export const ProductsContext = createContext();
// const ProductsContextProvider = ({ children }) => {
//   const [products] = useState(DATA_PRODS);

//   const [productState, productDispatch] = useReducer(ProductReducer, {
//     byCategpry: false,
//     bySize: false,
//     byPrice: 0,
//     byBrand: "",
//   });
//   console.log("clg inside the prod contxt", productState);
//   return (
//     <ProductsContext.Provider
//       value={{ products, productState, productDispatch }}
//     >
//       {children}
//     </ProductsContext.Provider>
//   );
// };

// export default ProductsContextProvider;

export const ProductsContext = createContext();

const ProductsContextProvider = ({ children }) => {
  const [products] = useState(DATA_PRODS);

  const [productState, productDispatch] = useReducer(ProductReducer, {
    byStock: false,
    byFastDelivery: false,
    byRating: 0,
    searchQuery: "",
  });

  const filterProducts = (products, brand) => (dispatch) => {
    dispatch({
      type: FILTER_PRODUCTS_BY_BRAND,
      payload: {
        brand: brand,
        items:
          brand === ""
            ? products
            : products.filter((x) => x.brand === brand >= 0),
      },
    });
  };
  // console.log(productState);
  return (
    <ProductsContext.Provider
      value={{ products, productState, productDispatch, filterProducts }}
    >
      {children}
    </ProductsContext.Provider>
  );
};

export default ProductsContextProvider;
